export default __webpack_public_path__ + "assets/ak-cached/2h/images/Hulu_DisneyPlus_ESPNPlus_LogoGrouped.svg";